
export default {
    setRoute({commit}, data) {
        commit('SET_ROUTE', data)
    },
    setDrawer({commit}, data) {
        commit('SET_DRAWER', data);
    },
    setLoading({commit}, data) {
        commit('SET_LOADING', data)
    },
    setPageLoading({commit}, data) {
        commit('SET_PAGE_LOADING', data)
    },
    setUser({commit}, data) {
        commit('SET_USER', data)
    },
    setAlert ({ commit }, data) {
        commit('SET_ALERT', data)
    },
    setAuthorization ({commit}, data) {
        commit('SET_AUTHORIZATION', data)
    },
    setMails ({commit}, data) {
        commit('SET_MAILS', data)
    },
    setUnread ({commit}, data) {
        commit('SET_UNREAD', data)
    }
}
